import { render, staticRenderFns } from "./terminalDetail.vue?vue&type=template&id=d9b76482&scoped=true&"
import script from "./terminalDetail.vue?vue&type=script&lang=js&"
export * from "./terminalDetail.vue?vue&type=script&lang=js&"
import style0 from "./terminalDetail.vue?vue&type=style&index=0&id=d9b76482&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b76482",
  null
  
)

export default component.exports